import React from 'react'
import {connect} from 'react-redux'
import { Route, Switch } from 'react-router';

import {FAQModel} from '/app/src/model'
import {Flex} from '/app/src/component'

import CategoryRightPanel from './HelpDesk/Category'
import CategoryUpdateRightPanel from './HelpDesk/CategoryUpdate'
import MainMenuRightPanel from '/app/src/layout/Dashboard/RightPanel/MainMenu'
import FeedbackRightPanel from './HelpDesk/Feedback'

class HelpDeskRightPanel extends React.Component {
    render() {
        if(!this.props.currentItemId || this.props.menuToogle){
            return (
                <Switch>
                    <Route path='/clientChat/faq/helpdesk/feedback/*'
                        component={FeedbackRightPanel} />
                    <Route path='/' component={MainMenuRightPanel}/>
                </Switch>
            )
        }
        return (
            <Flex w='100%' h='100%' overflowY='auto'>
                <Switch>
                    <Route path='/clientChat/faq/helpdesk/category/:id/update/:itemId'
                        render={ (props) => <CategoryUpdateRightPanel faqId={this.props.currentItemId}/> }/>

                    <Route path='/clientChat/faq/helpdesk/category/:id/create'
                        render={ (props) => <CategoryUpdateRightPanel faqId={0}/> } />

                    <Route path='/clientChat/faq/helpdesk/category/:id'
                        render={ (props) => <CategoryRightPanel faqId={this.props.currentItemId}/> } />
                    <Route path='/' component={MainMenuRightPanel}/>
                </Switch>
            </Flex>
        )
    }
}


const {selector: currentItemSelector} = FAQModel.setCurrentItem()

function mapStateToProps(state, ownProps) {
    let currentItemId = currentItemSelector(state)['current']
    return {
        menuToogle: state.getIn(['system', 'menu', 'toogle']),
        currentItemId,
    }
}


export default connect(mapStateToProps)(HelpDeskRightPanel)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/ClientChatMenu/index.js